// extracted by mini-css-extract-plugin
export default {"questions":"styles_questions__jDUQ9","modalContainer":"styles_modalContainer__PG3xb"};